import * as types from '../actions/action-types';

export function categories(state = {home: {items: []}, menu: {items: []}, openCategory: null}, action) {
  switch (action.type) {
    case types.REQUEST_CATEGORIES:
      return {...state, [action.categoriesType]: {items: [], isFetching: true}};

    case types.RECEIVE_CATEGORIES:
      return {...state, [action.categoriesType]: {items: action.items, receivedAt: action.receivedAt, isFetching: false, market: action.market}};

    case types.OPEN_CATEGORY:
      return {...state, openCategory: action.category};

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/categories.js